import { formatFR, formatShort } from '../lib/dates.js';

// Le triangle de `select.saisie` du kit, au même dessin : ce champ se range entre deux <select>
// (QuickAdd, détail de tâche) et ne doit pas porter une autre flèche qu'eux.
const CARET: React.CSSProperties = {
  backgroundImage:
    'linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, transparent 50%)',
  backgroundPosition: '0 0, 0.3125rem 0',
  backgroundSize: '0.3125rem 0.3125rem',
  backgroundRepeat: 'no-repeat',
};

/**
 * Une date, dite en clair (« Tomorrow (01/10/2026) ») dans une `.saisie` du kit, et choisie
 * par le sélecteur natif : une saisie `type="date"` transparente recouvre le libellé, et ouvre
 * son calendrier au clic — sur un bureau, le navigateur ne l'ouvre sinon que sur son icône.
 */
export function DateField({
  value,
  onChange,
  label,
}: {
  value: string | null;
  onChange: (date: string | null) => void;
  label: string;
}): React.ReactElement {
  return (
    <span className="relative block">
      <span className="saisie flex items-center justify-between gap-2" aria-hidden>
        {value ? (
          <span className="truncate">
            {formatShort(value)} <span className="text-muted">({formatFR(value)})</span>
          </span>
        ) : (
          <span className="text-muted">none</span>
        )}
        <span className="shrink-0 w-2.5 h-[0.3125rem] -mr-px" style={CARET} />
      </span>
      <input
        type="date"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
        onClick={(e) => {
          try {
            e.currentTarget.showPicker();
          } catch {
            // Pas de sélecteur à ouvrir (navigateur ancien, saisie désactivée) : la saisie reste.
          }
        }}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        aria-label={label}
      />
    </span>
  );
}
